import { useEffect, useState } from 'react';
import { api } from '../lib/api';

/**
 * §1bis.5 — las novedades ya no se ofrecen en el alta (ningún consentimiento nace marcado):
 * se ofrecen aquí. Mismo registro que V78 (estado revocable + el otorgamiento en
 * legal_acceptances). Cada usuario decide por sí mismo.
 */
export function MarketingConsentCard() {
  const [state, setState] = useState<{ optIn: boolean; decidedAt: string | null } | null>(null);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    api<{ optIn: boolean; decidedAt: string | null }>('/legal/marketing-consent').then(setState).catch(() => setErr('No se pudo cargar tu preferencia.'));
  }, []);

  const toggle = async (optIn: boolean) => {
    setBusy(true); setErr(null);
    try {
      setState(await api('/legal/marketing-consent', { method: 'PUT', body: { optIn } }));
    } catch { setErr('No se pudo guardar. Intenta de nuevo.'); } finally { setBusy(false); }
  };

  return (
    <div className="card-soft rounded-2xl border border-slate-200/80 bg-white p-6">
      <h3 className="font-serif text-lg tracking-tight text-slate-900">Novedades de FluidSol</h3>
      <p className="mt-1 text-sm text-slate-500">
        Recibe por correo novedades, mejoras y comunicaciones de FluidSol. Es opcional y puedes cambiarlo cuando quieras.
      </p>
      {state && (
        <label className="mt-4 flex items-center gap-2.5 text-sm text-slate-700">
          <input type="checkbox" className="h-4 w-4 rounded border-slate-300" checked={state.optIn} disabled={busy}
            onChange={(e) => toggle(e.target.checked)} />
          Quiero recibir novedades
        </label>
      )}
      {err && <p className="mt-2 text-sm text-rose-600">{err}</p>}
    </div>
  );
}
